import { orders } from './orders.reducer';

export default {
  orders
}